export const cultivation_bestFitName = (crop: {name: string}, variety: {alternativeCropName: string | null}) => {
  return variety.alternativeCropName ? variety.alternativeCropName : crop.name;
};
